class FacetFiltersForm extends HTMLElement {
  static _didAutoInit = false;

  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    if (facetForm) {
      facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    }

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    if (!FacetFiltersForm._didAutoInit) {
      FacetFiltersForm._didAutoInit = true;

      FacetFiltersForm.getSections().forEach((section) => {
        const searchParams = new URLSearchParams(window.location.search);
        const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}&filter.v.availability=1`;
        const filterDataUrl = (element) => element.url === url;

        FacetFiltersForm.filterData.some(filterDataUrl)
          ? FacetFiltersForm.renderFilterFromCache(filterDataUrl)
          : FacetFiltersForm.renderFilterFromFetch(url);
      });
    }
  }

  static _normalizeSearchParams(spString) {
    const sp = new URLSearchParams(spString || '');
    sp.delete('vtp_page');
    sp.delete('page');
    return sp.toString();
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const raw = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;

      const norm = FacetFiltersForm._normalizeSearchParams(raw);
      const prevNorm = FacetFiltersForm._normalizeSearchParams(FacetFiltersForm.searchParamsPrev);

      if (norm !== prevNorm) {
        FacetFiltersForm.renderPage(raw, null, false);
      } else {
        if (typeof VariantTilePager !== 'undefined' && VariantTilePager.syncFromUrl) {
          VariantTilePager.syncFromUrl();
        }
      }
    };

    window.addEventListener('popstate', onHistoryChange);
  }


  static toggleActiveFacets(disable = true) {
    const filterAccordions = document.querySelectorAll('[id^="Details-filter"]');
    for (const accordion of filterAccordions) {
      const active = !!accordion.querySelector('.mobile-facets__checkbox:checked');
      accordion.classList.toggle('has-active-selections', active);
    }

    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();

    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');

    const gridContainer = document.getElementById('ProductGridContainer');
    const collectionEl = gridContainer?.querySelector('.collection');
    if (collectionEl) collectionEl.classList.add('loading');

    if (countContainer) countContainer.classList.add('loading');
    if (countContainerDesktop) countContainerDesktop.classList.add('loading');

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
          ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
          : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderFilterFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then(responseText => {
      const html = responseText;
      FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
      FacetFiltersForm.renderFilters(html, event);
    });
  }

  static renderFilterFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
  }

  static renderProductGridContainer(html) {
    const container = document.getElementById('ProductGridContainer');
    if (container) container.dataset.vtpPending = '1'; // ✅ ДО swap

    const next = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer')?.innerHTML;

    if (container && typeof next === 'string') container.innerHTML = next;

    VariantTilePager.resetFromDOM();

    document.dispatchEvent(new CustomEvent('facets-grid-update', { bubbles: true }));
    // window.scrollTo(0, 0);
  }

  static renderProductCount(html) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const count = parsed.getElementById('ProductCount')?.innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    if (container) {
      container.innerHTML = count;
      container.classList.remove('loading');
    }
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElements = parsedHTML.querySelectorAll(
        '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    facetDetailsElements.forEach((element) => {
      const target = document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`);
      if (target) target.innerHTML = element.innerHTML;
    });
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  // static getSections() {
  //   return [
  //     {
  //       section: document.getElementById('product-grid').dataset.id,
  //     },
  //   ];
  // }
  static getSections() {
  const productGrid = document.getElementById('product-grid');

  // CWI CODE N
  customLazyLoad();

  if (!productGrid) return [];

  return [
    {
      section: productGrid.dataset.id,
    },
  ];
}


  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    const forms = [];
    sortFilterForms.forEach((form) => {
      forms.push(this.createSearchParams(form));
    });
    this.onSubmitForm(forms.join('&'), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.includes('?')
        ? event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1)
        : '';
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

/**
 * VariantTilePager
 * - Makes "virtual pages" of tiles (24 tiles/page)
 * - Loads extra Shopify product-pages as needed (via section_id + page)
 * - Mixes tiles within current tile-page to avoid same data-group adjacent
 * - Updates "You've viewed X of Y products"
 *
 * IMPORTANT:
 * - Requires:
 *   1) <div id="ProductGridContainer" data-total-pages="{{ paginate.pages }}">
 *   2) each tile <li> has data-group="{{ product.id }}"
 *   3) controls exist:
 *      #variant-pagination-status
 *      #variant-pagination-controls
 *      #prev-page, #next-page
 */
const VariantTilePager = (() => {
  const PAGE_SIZE = 24;
  const COUNT_TOTAL_TILES_MODE = 'eager';
  const DEBUG = false;

  let tilePage = 1;

  let sectionId = null;
  let totalProductPages = 1;
  let loadedProductPages = 1;

  let baseParams = null;
  let tilesPool = [];
  let productPageCache = new Map();
  let totalTiles = null;

  let orderedPool = null;
  let orderedPoolKey = '';
  let resetRunId = 0;
  let appendMode = false;

  function getUrlTilePage() {
    const n = Number(new URLSearchParams(window.location.search).get('vtp_page') || 1);
    return Number.isFinite(n) && n > 0 ? Math.floor(n) : 1;
  }

  function setUrlTilePage(page, { replace = false } = {}) {
    const sp = new URLSearchParams(window.location.search);
    sp.delete('page');
    if (page <= 1) sp.delete('vtp_page');
    else sp.set('vtp_page', String(page));

    const newSearch = sp.toString();
    const url = `${window.location.pathname}${newSearch ? '?' + newSearch : ''}`;

    const state = (history.state && typeof history.state === 'object')
      ? { ...history.state, searchParams: newSearch }
      : { searchParams: newSearch };

    if (replace) history.replaceState(state, '', url);
    else history.pushState(state, '', url);
  }

  function totalTilePages() {
    if (totalTiles === null) return null;
    return Math.max(1, Math.ceil(totalTiles / PAGE_SIZE));
  }

  function buildPageModel(current, total) {
    const delta = 2;
    const keep = new Set([1, total]);

    for (let p = current - delta; p <= current + delta; p++) {
      if (p > 1 && p < total) keep.add(p);
    }

    const pages = Array.from(keep).sort((a, b) => a - b);
    const model = [];

    let last = null;
    for (const p of pages) {
      if (last !== null && p - last > 1) model.push({ type: 'gap' });
      model.push({ type: 'page', page: p });
      last = p;
    }
    return model;
  }

  function renderPager() {
    const { pagerNav, pagerList } = dom();
    const total = totalTilePages();
    if (!pagerNav || !pagerList) return;

    if (!total || total <= 1) {
      pagerNav.hidden = true;
      pagerList.innerHTML = '';
      return;
    }

    pagerNav.hidden = false;

    const cur = tilePage;
    const model = buildPageModel(cur, total);

    const prevDisabled = cur <= 1;
    const nextDisabled = cur >= total;

    const chevronLeft = '<span class="svg-wrapper"><svg aria-hidden="true" focusable="false" class="icon icon-caret" width="8" height="10" viewBox="0 0 8 10" fill="none">\n' +
      '    <g><path d="M4 8.5L0.535898 2.5L7.4641 2.5L4 8.5Z" fill="currentColor"></path></g>\n' +
      '</svg></span>';  // ‹
    const chevronRight = '<span class="svg-wrapper"><svg aria-hidden="true" focusable="false" class="icon icon-caret" width="8" height="10" viewBox="0 0 8 10" fill="none">\n' +
      '    <g><path d="M4 8.5L0.535898 2.5L7.4641 2.5L4 8.5Z" fill="currentColor"></path></g>\n' +
      '</svg></span>'; // ›

    const makeHref = (p) => {
      const sp = new URLSearchParams(window.location.search);
      sp.delete('page');
      if (p <= 1) sp.delete('vtp_page'); else sp.set('vtp_page', String(p));
      const qs = sp.toString();
      return `${window.location.pathname}${qs ? '?' + qs : ''}`;
    };

    let html = '';

    if (!prevDisabled) {
      html += `
        <li class="pagination__item">
          <a class="pagination__item pagination__item--next pagination__item-arrow link motion-reduce"
             href="${makeHref(cur - 1)}" data-vtp-page="${cur - 1}" aria-label="Previous">
            ${chevronLeft}
          </a>
        </li>
      `;
    }

    for (const it of model) {
      if (it.type === 'gap') {
        html += `<li class="pagination__item"><span class="pagination__item">…</span></li>`;
        continue;
      }
      const p = it.page;
      const isCur = p === cur;
      html += `
      <li class="pagination__item">
        ${
          isCur
            ? `<span class="pagination__item pagination__item--current" aria-current="page">${p}</span>`
            : `<a class="pagination__item" href="${makeHref(p)}" data-vtp-page="${p}">${p}</a>`
        }
      </li>
    `;
    }

    if (!nextDisabled) {
      html += `
        <li class="pagination__item">
          <a class="pagination__item pagination__item--prev pagination__item-arrow link motion-reduce"
             href="${makeHref(cur + 1)}" data-vtp-page="${cur + 1}" aria-label="Next">
            ${chevronRight}
          </a>
        </li>
      `;
    }

    pagerList.innerHTML = html;

    pagerList.onclick = (e) => {
      const a = e.target.closest('a[data-vtp-page]');
      if (!a || a.getAttribute('aria-disabled') === 'true') return;
      e.preventDefault();
      appendMode = false;
      goTo(Number(a.dataset.vtpPage), { push: true });
    };
  }
  function renderLoadMore() {
    const { loadMore } = dom();
    const total = totalTilePages();
    if (!loadMore) return;

    if (!total || tilePage >= total) {
      loadMore.hidden = true;
      return;
    }

    loadMore.hidden = false;
    loadMore.onclick = async () => {
      appendMode = true;
      await goTo(tilePage + 1, { push: true, append: true });
    };
  }

  let poolLoadChain = Promise.resolve();

  function q(fn) {
    poolLoadChain = poolLoadChain.then(fn, fn);
    return poolLoadChain;
  }

  function dom() {
    const pagerNav = document.getElementById('variant-pagination');

    // CWI CODE N
    customLazyLoad();
    
    return {
      container: document.getElementById('ProductGridContainer'),
      grid: document.querySelector('ul#product-grid'),
      status: document.getElementById('variant-pagination-status'),
      controls: document.getElementById('variant-pagination-controls'),
      pagerNav,
      pagerList: pagerNav ? pagerNav.querySelector('.pagination__list') : null,
      loadMore: document.getElementById('variant-load-more'),
    };
  }

  function readBaseParams() {
    const sp = new URLSearchParams(window.location.search);
    sp.delete('page');
    sp.delete('section_id');
    baseParams = sp;
  }

  function readMetaFromDOM() {
    const { container, grid } = dom();

    sectionId = grid?.dataset?.id || null;
    totalProductPages = Number(container?.dataset?.totalPages || 1);

    loadedProductPages = 1;
    tilesPool = [];
    productPageCache = new Map();
    totalTiles = null;

    orderedPool = null;
    orderedPoolKey = '';

    readBaseParams();
  }

  function isPriceSort() {
    const sortBy = new URLSearchParams(window.location.search).get('sort_by') || '';
    return sortBy.toLowerCase().includes('price');
  }

  function getPriceSortDir() {
    const sortBy = (new URLSearchParams(window.location.search).get('sort_by') || '').toLowerCase();
    return sortBy.includes('desc') ? -1 : 1;
  }

  function parseTilesFromGridEl(gridEl) {
    if (!gridEl) return [];
    const lis = Array.from(gridEl.querySelectorAll(':scope > li'));

    // CWI CODE N
    customLazyLoad();

    return lis.map((li) => ({
      group: li?.dataset?.group || '',
      variantId: li?.dataset?.variantId || '',
      color: li?.dataset?.color || '',
      price: Number(li?.dataset?.priceCents || 0),
      html: li.outerHTML,
      seq: 0,
    }));
  }

  function buildSectionUrl(pageNum) {
    const params = new URLSearchParams(baseParams);
    if (sectionId) params.set('section_id', sectionId);
    params.set('page', String(pageNum));
    return `${window.location.pathname}?${params.toString()}`;
  }

  async function fetchProductPageTiles(pageNum) {
    if (productPageCache.has(pageNum)) return productPageCache.get(pageNum);

    const url = buildSectionUrl(pageNum);
    const res = await fetch(url, { credentials: 'same-origin' });
    const text = await res.text();
    const doc = new DOMParser().parseFromString(text, 'text/html');
    const gridEl = doc.querySelector('ul#product-grid');

    const tiles = parseTilesFromGridEl(gridEl);

    // CWI CODE N
    customLazyLoad();

    productPageCache.set(pageNum, tiles);
    return tiles;
  }

  function dedupePool(tag = '') {
    const seen = new Set();
    const before = tilesPool.length;

    tilesPool = tilesPool.filter((t) => {
      const key = t.variantId || t.html;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });

    if (DEBUG && before !== tilesPool.length) {
      console.warn(`[VTP] dedupePool ${tag}: ${before} -> ${tilesPool.length}`);
    }
  }

  function debugState(label) {
    if (!DEBUG) return;

    const uniqVar = new Set(tilesPool.map(t => t.variantId).filter(Boolean));
    const dupes = tilesPool.length - uniqVar.size;

    const groups = new Map();
    for (const t of tilesPool) groups.set(t.group, (groups.get(t.group) || 0) + 1);

    console.groupCollapsed(
      `[VTP] ${label} | pool=${tilesPool.length} uniqVar=${uniqVar.size} dupes=${dupes} loadedPages=${loadedProductPages}/${totalProductPages} totalTiles=${totalTiles}`
    );
    console.log({
      tilePage,
      PAGE_SIZE,
      sort_by: new URLSearchParams(window.location.search).get('sort_by'),
      pool: tilesPool.length,
      uniqVar: uniqVar.size,
      dupes,
      loadedProductPages,
      totalProductPages,
      totalTiles,
    });

    if (dupes > 0) {
      const seen = new Set();
      const d = [];
      for (const t of tilesPool) {
        const k = t.variantId || '';
        if (!k) continue;
        if (seen.has(k)) d.push({ variantId: k, group: t.group, color: t.color, price: t.price });
        else seen.add(k);
      }
      console.table(d.slice(0, 30));
    }

    const topGroups = Array.from(groups.entries())
      .sort((a, b) => b[1] - a[1])
      .slice(0, 20)
      .map(([group, count]) => ({ group, count }));
    console.table(topGroups);

    console.groupEnd();
  }

  function buildInterleavedPool(pool) {
    const groupOrder = [];
    const groups = new Map();

    for (const t of pool) {
      const g = t.group || '';
      if (!groups.has(g)) {
        groups.set(g, []);
        groupOrder.push(g);
      }
      groups.get(g).push(t);
    }

    let maxLen = 0;
    for (const arr of groups.values()) maxLen = Math.max(maxLen, arr.length);

    const out = [];
    for (let i = 0; i < maxLen; i++) {
      for (const g of groupOrder) {
        const arr = groups.get(g);
        if (arr && arr[i]) out.push(arr[i]);
      }
    }
    return out;
  }

  function rebuildOrderedPoolIfNeeded() {
    if (isPriceSort()) {
      orderedPool = null;
      orderedPoolKey = '';
      return;
    }

    const key = `${tilesPool.length}::${tilesPool.map(t => t.group || '').sort().join(',')}`;
    if (key === orderedPoolKey) return;

    orderedPool = buildInterleavedPool(tilesPool);
    orderedPoolKey = key;
  }

  function getRenderPool() {
    rebuildOrderedPoolIfNeeded();
    return orderedPool || tilesPool;
  }

  async function ensurePoolSize(minSize) {
    return q(async () => {
      while (tilesPool.length < minSize && loadedProductPages < totalProductPages) {
        const nextPage = loadedProductPages + 1;
        const tiles = await fetchProductPageTiles(nextPage);

        const existing = new Set(tilesPool.map(t => t.variantId).filter(Boolean));
        let seq = tilesPool.length;

        const toAdd = [];
        for (const t of tiles) {
          const vid = t.variantId || '';
          if (vid && existing.has(vid)) continue;
          if (vid) existing.add(vid);

          t.seq = seq++;
          toAdd.push(t);
        }

        tilesPool = tilesPool.concat(toAdd);
        loadedProductPages = nextPage;

        dedupePool(`after add page ${nextPage}`);
        rebuildOrderedPoolIfNeeded();

        debugState(`loaded product-page ${nextPage}, added ${toAdd.length}/${tiles.length}`);
      }

      if (loadedProductPages >= totalProductPages) {
        dedupePool('final');
        totalTiles = tilesPool.length;
      }
    });
  }

  async function ensureAllTilesLoaded() {
    await ensurePoolSize(Number.MAX_SAFE_INTEGER);
  }

  function updateUI() {
    const { status, controls, prev, next } = dom();
    if (controls) controls.style.display = '';

    const viewed = Math.min(tilePage * PAGE_SIZE, tilesPool.length);
    const total = (totalTiles !== null) ? totalTiles : '…';

    if (status) status.textContent = `You've viewed ${viewed} of ${total} products`;

    if (prev) prev.disabled = tilePage <= 1;

    const noMoreTilesKnown = (totalTiles !== null) && (viewed >= totalTiles);
    if (next) next.disabled = noMoreTilesKnown;

    renderPager();
    renderLoadMore();
  }

  function renderTilePage() {
    const { grid } = dom();
    if (!grid) return;

    const start = appendMode ? 0 : (tilePage - 1) * PAGE_SIZE;
    const end = tilePage * PAGE_SIZE;

    let pool = tilesPool;

    if (isPriceSort()) {
      const dir = getPriceSortDir();
      pool = [...tilesPool].sort((a, b) => {
        if (a.price !== b.price) return dir * (a.price - b.price);
        return a.seq - b.seq;
      });
    } else {
      pool = getRenderPool();
    }

    const slice = pool.slice(start, end);
    grid.innerHTML = slice.map(t => t.html).join('');

    if (typeof initializeScrollAnimationTrigger === 'function') {
      try { initializeScrollAnimationTrigger(grid.innerHTML); } catch (e) {}
    }

    updateUI();
  }

  async function goTo(pageNum, { push = true, append = false } = {}) {
    tilePage = Math.max(1, pageNum);
    appendMode = !!append;

    const need = tilePage * PAGE_SIZE;
    await ensurePoolSize(need);

    if (totalTiles !== null) {
      const maxPage = Math.max(1, Math.ceil(totalTiles / PAGE_SIZE));
      if (tilePage > maxPage) tilePage = maxPage;
    }

    if (isPriceSort()) {
      await ensureAllTilesLoaded();
    }

    renderTilePage();
    if (push) setUrlTilePage(tilePage);
  }

  async function eagerCountAllTiles() {
    await ensureAllTilesLoaded();
    updateUI();
  }

  async function resetFromDOM() {
    const runId = ++resetRunId;

    const c = document.getElementById('ProductGridContainer');
    if (c) c.dataset.vtpPending = '1';

    const { grid, controls, status } = dom();

    if (!grid) {
      if (controls) controls.style.display = 'none';
      if (status) status.textContent = '';
      return;
    }

    readMetaFromDOM();

    tilesPool = parseTilesFromGridEl(grid);
    tilesPool.forEach((t, i) => { t.seq = i; });

    dedupePool('reset');
    rebuildOrderedPoolIfNeeded();

    appendMode = false;
    await goTo(getUrlTilePage(), { push: false });

    setUrlTilePage(tilePage, { replace: true });

    if (COUNT_TOTAL_TILES_MODE === 'eager' && !isPriceSort()) {
      await eagerCountAllTiles();
    } else {
      updateUI();
    }

    if (runId === resetRunId) {
      const c = document.getElementById('ProductGridContainer');
      if (c) c.dataset.vtpPending = '0';
    }

    debugState('reset done');
  }

  async function syncFromUrl() {
    appendMode = false;
    const p = getUrlTilePage();
    await goTo(p, { push: false, append: false });
  }

  return { resetFromDOM, syncFromUrl };
})();

document.addEventListener('DOMContentLoaded', () => {
  VariantTilePager.resetFromDOM();
});